<template>
  <div class="upload-dragger-component">
    <input
        type="file"
        ref="fileInput"
        accept=""
        multiple="multiple"
        @change="handleInputChange"
        :disabled="hasError"
        data-dusk="file-upload-input"
    />

    <div v-if="hasError === false"
         class="drop-container"
         v-bind:class="{ active: dropContainerActive}"
         v-cloak
         @drop.prevent="handleDrop"
         @dragstart.prevent="handleDropContainerActive"
         @dragover.prevent="handleDropContainerActive"
         @dragenter.prevent="handleDropContainerActive"
         @dragleave.prevent="handleDropContainerInactive"
         @click="onClick"
    >
      <p class="upload-drag-icon">
        <a-icon type="inbox"/>
      </p>
      <p class="upload-title">
        Klik hier of sleep het bestand naar dit gebied om het te uploaden
      </p>
      <p class="upload-hint">
        Upload meerdere bestanden tegelijk.
      </p>
    </div>

    <div v-else class="drop-container">
      <a-alert
          message="Er is iets fout gegaan"
          description="Er is iets fout gegaan ter voorbereiding voor het uploaden."
          type="error"
          show-icon
      />
    </div>

    <template v-for="(file, key) in files">
      <FileComponent
          :file="file"
          :ref="file.uuid"
          :key="file.uuid"
          v-on:updated-document="onUpdatedDocument"
          :data-dusk="'file-component-' + key"
      ></FileComponent>
    </template>
  </div>
</template>
<script>
import DocumentUploadComponent from "./DocumentUploadComponent.vue";

const uuid = require('uuid');
import FileComponent from './FileComponent';

export default {
  name: "UploadDraggerComponent",
  props: {
    upload: {
      type: Function,
      required: false,
      default: null
    },
    filter: {
      type: Function,
      required: false,
      default: null
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DocumentUploadComponent,
    FileComponent
  },
  data() {
    return {
      files: [],
      dropContainerActive: false,
    };
  },
  computed: {
    hasNextPage() {
      return this.pages > this.page;
    },
  },
  methods: {
    handleDrop(e) {
      this.handleDropContainerInactive();
      let files = e.dataTransfer.files;
      [...files].forEach(file => {
        this.uploadFile(file);
      });
    },
    handleDropContainerActive() {
      this.dropContainerActive = true;
    },
    handleDropContainerInactive() {
      this.dropContainerActive = false;
    },
    handleInputChange(e) {
      let files = e.target.files;
      [...files].forEach(file => {
        this.uploadFile(file);
      });
      e.target.value = null;
    },
    async uploadFile(file) {
      file.uuid = uuid.v4();
      this.files.unshift(file);

      await this.$nextTick(() => {
        this.upload({
          file: file,
          onError: (e) => {
            this.onFileError(file, e);
          },
          onSuccess: (e) => {
            this.onFileSuccess(file, e);
          },
          onProgress: (e) => {
            this.onFileProgress(file, e);
          },
        })
      });
    },
    onClick() {
      this.$refs.fileInput.click();
    },
    onUpdatedDocument(document) {
      this.$emit('updated-document', document);
    },
    onFileError(file, e) {
      let fileComponent = this.$refs[file.uuid][0];

      if (typeof fileComponent !== "undefined") {
        fileComponent.onError(e);
      }
    },
    onFileSuccess(file, e) {
      let fileComponent = this.$refs[file.uuid][0];

      if (typeof fileComponent !== "undefined") {
        fileComponent.onSuccess(e);
      }
    },
    onFileProgress(file, e) {
      let fileComponent = this.$refs[file.uuid][0];

      if (typeof fileComponent !== "undefined") {
        fileComponent.onProgress(e);
      }
    },
    clearFiles() {
      this.files = [];
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.upload-dragger-component {
  display: flex;
  flex-direction: column;
  row-gap: $spacing-sm;
}
.upload-dragger-component .drop-container {
  position: relative;
  width: 100%;
  text-align: center;
  background: $main-content-bg-color;
  border-radius: $border-radius-large;
  cursor: pointer;
  transition: border-color .3s;
  padding: $spacing-md;
}

.upload-dragger-component .drop-container:hover,
.upload-dragger-component .drop-container.active {
  border-color: #40a9ff;
}

.upload-dragger-component .drop-container .upload-drag-icon {
  transition: color .3s;
  color: #00000054;
  font-size: 48px;
  margin-bottom: 10px;
  margin-top: 15px;
}

.upload-dragger-component .drop-container:hover .upload-drag-icon,
.upload-dragger-component .drop-container.active .upload-drag-icon {
  color: #40a9ff;
}

.upload-dragger-component .drop-container .upload-title {
  margin: 0 0 4px;
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
}

.upload-dragger-component .drop-container .upload-hint {
  color: rgba(0, 0, 0, .45);
  font-size: 14px;
}

.upload-dragger-component input[type="file"] {
  display: none;
}

</style>
